import { AuthProvider } from "../contexts/AuthContext";
import { PageNameProvider } from "../contexts/PageTitleContext";
import { SignalRProvider } from "../contexts/SignalRContext";
import DashboardLayout from "./DashboardLayout";

/**
 * Wrapper component that provides authentication and other context providers
 * for protected routes. Public routes should use PublicLayout instead.
 */
export default function AuthenticatedLayout() {
  return (
    <AuthProvider>
      <PageNameProvider>
        <SignalRProvider>
          <DashboardLayout />
        </SignalRProvider>
      </PageNameProvider>
    </AuthProvider>
  );
}

